export type LossControlDisplayMode = 'operators' | 'products';

interface BuildDisplayPathOptions {
  branchId: string;
  mode: LossControlDisplayMode;
  demo: boolean;
  token?: string;
}

export function parseLossControlDisplayMode(
  value: string | null,
): LossControlDisplayMode {
  return value === 'products' ? 'products' : 'operators';
}

export function buildLossControlDisplayPath({
  branchId,
  mode,
  demo,
  token = '',
}: BuildDisplayPathOptions): string {
  const query = new URLSearchParams({ mode });
  if (demo) query.set('demo', '1');

  const hash = !demo && token ? `#token=${encodeURIComponent(token)}` : '';

  return `/loss-control/display/${encodeURIComponent(
    branchId,
  )}?${query.toString()}${hash}`;
}
